export default __webpack_public_path__ + "static/media/Shadowbrood Gloves.2e872b45.jpg";